import { FC } from 'react';

import { useCommunicationKeepAlive } from '../gameGrid/hooks/useCommunicationKeepAlive';

export const GameKeepAliveManager: FC = () => {
  useCommunicationKeepAlive();
  return null;
};
